import { AspectRatioIcon } from './AspectRatioIcon';
import { ASPECT_RATIO_LABELS } from '../../utils/aspectRatio';
import { Button } from './Button';

const ICON_SIZE = 40;
const TEXT_COLOR = 'rgba(245, 241, 230, 0.85)';
const TEXT_COLOR_DIM = 'rgba(245, 241, 230, 0.5)';

function getRatioDisplayName(ratio: string): string {
  if (ratio === 'none') return '指定なし';
  return ASPECT_RATIO_LABELS[ratio] || ratio;
}

type AspectRatioPreviewProps = {
  currentRatio: string;
  targetRatio: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  cancelLabel?: string;
  confirmLabel?: string;
};

export function AspectRatioPreview({
  currentRatio,
  targetRatio,
  onCancel,
  onConfirm,
  cancelLabel,
  confirmLabel,
}: AspectRatioPreviewProps) {
  const isCurrentNone = !currentRatio || currentRatio === 'none';
  const hasButtons = onCancel && onConfirm;

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 28, margin: '16px 0 8px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: ICON_SIZE, height: ICON_SIZE }}>
          {isCurrentNone ? (
            <div style={{ width: 32, height: 32, border: '2px dashed rgba(245, 241, 230, 0.25)', borderRadius: 4 }} />
          ) : (
            <AspectRatioIcon ratio={currentRatio} size={ICON_SIZE} style={{ color: TEXT_COLOR_DIM }} />
          )}
        </div>
        <span style={{ fontSize: 12, color: TEXT_COLOR_DIM }}>{getRatioDisplayName(currentRatio)}</span>
        {hasButtons && (
          <Button variant="muted" size="sm" onClick={onCancel} style={{ marginTop: 8 }}>
            {cancelLabel || `${currentRatio === 'none' ? '指定なし' : currentRatio} のまま`}
          </Button>
        )}
      </div>
      <span style={{ fontSize: 18, color: 'rgba(245, 241, 230, 0.4)', marginBottom: hasButtons ? 46 : 18 }}>→</span>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: ICON_SIZE, height: ICON_SIZE }}>
          <AspectRatioIcon ratio={targetRatio} size={ICON_SIZE} style={{ color: TEXT_COLOR }} />
        </div>
        <span style={{ fontSize: 12, color: TEXT_COLOR, fontWeight: 600 }}>{getRatioDisplayName(targetRatio)}</span>
        {hasButtons && (
          <Button variant="primary" size="sm" onClick={onConfirm} style={{ marginTop: 8 }}>
            {confirmLabel || `${targetRatio} に変更`}
          </Button>
        )}
      </div>
    </div>
  );
}
